var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsAdLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 954.1 158.2",
    width: 2500,
    height: 415,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#00aaf2}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title4"
  }, "active-directory") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title4"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_",
    transform: "translate(0 -33.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6",
    className: "st0",
    d: "M158.6 154.2v33.3c0 3.9-1.2 4.7-4.9 4.1-24.8-3.7-49.9-7.1-74.9-10.6-4.5-.6-6.1-2.2-6.1-7.1.4-17.7.2-35.5 0-53.4 0-3.9 1.2-5.1 5.1-5.1 25.6.2 50.8.2 75.9.2 4.1 0 5.1 1.6 5.1 5.3-.4 11.2-.2 22.2-.2 33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    className: "st0",
    d: "M116.1 109.2c-12.6 0-25.2-.2-37.8 0-3.9 0-5.5-.8-5.5-5.3.2-18.1.2-35.9 0-53.8 0-3.5 1.2-4.7 4.5-5.3 25.8-3.7 51.6-7.3 77.4-11.2 4.5-.6 3.7 2.4 3.7 4.9 0 16 .2 32.3 0 48.3 0 5.9-.2 11.8 0 17.7.2 3.7-1.2 4.7-4.7 4.7-12.4-.2-25 0-37.6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    className: "st0",
    d: "M32.7 115.9h28.2c3 0 4.3 1 4.3 4.1v55.6c0 3.2-1.4 3.5-4.3 3.2-18.7-2.8-37.4-5.5-56-8.1-3.7-.6-4.9-1.8-4.9-5.7.2-14.8.2-29.6 0-44.7 0-3.7 1-4.7 4.7-4.7 9.5.3 18.6.3 28 .3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    className: "st0",
    d: "M32.7 109.2H4.9c-3.5 0-4.7-1.2-4.7-4.9.2-14.6.2-29.2 0-43.9 0-3.5 1-4.7 4.7-5.3 18.7-2.4 37.4-5.1 56-8.1 4.3-.6 4.7.8 4.7 4.3v53.2c0 3.9-1.6 4.5-5.1 4.5-9.3 0-18.7.2-27.8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    className: "st0",
    d: "M228.8 64.7c-.2-3-.4-6.9-.4-9.7h-.2c-.6 2.6-1.8 5.7-2.8 8.7l-3.9 10.8h-2.2l-3.5-10.6c-1-2.8-1.8-5.9-2.6-8.7-.2 2.6-.2 6.5-.4 9.9l-.6 9.5h-2.6l1.6-22.5h3.7l3.9 11c1 2.6 1.6 5.3 2.2 7.7h.2c.6-2.2 1.4-4.9 2.4-7.7l4.1-11h3.7l1.4 22.5h-3.2l-.8-9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    className: "st0",
    d: "M240.4 53.9c0 1-.8 1.8-1.8 1.8h-.2c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8c1.2 0 2 .8 2 1.8zm-3.2 20.8v-16h3v16h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    className: "st0",
    d: "M256.4 74c-1.4.6-3 1-4.7 1-4.9 0-8.1-3.2-8.1-8.3-.2-4.7 3.2-8.5 7.9-8.7h.8c1.4 0 2.8.2 4.1.8l-.6 2.2c-1-.4-2.2-.8-3.5-.6-3.7 0-5.7 2.6-5.7 6.1 0 3.9 2.4 6.1 5.7 6.1 1.2 0 2.4-.2 3.5-.8l.6 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    className: "st0",
    d: "M259.7 63.5c0-1.8-.2-3.5-.2-4.9h2.6l.2 3.2h.2c.6-2 2.4-3.5 4.5-3.5.2 0 .6 0 .8.2v2.6c-.2-.2-.6-.2-1-.2-2 0-3.5 1.6-3.9 3.9 0 .4-.2.8-.2 1.2v8.7h-2.8l-.2-11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    className: "st0",
    d: "M285.1 66.5c.2 4.3-3 8.1-7.3 8.3h-.6c-4.3 0-7.7-3.2-7.7-8.3 0-5.5 3.7-8.5 8.1-8.5 4 0 7.5 3.5 7.5 8.5zm-12.8 0c0 3.2 1.6 6.1 4.9 6.1 3.2 0 4.9-3 4.9-6.1 0-2.8-1.2-6.3-4.9-6.3-3.9.2-4.9 3.5-4.9 6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    className: "st0",
    d: "M288.3 71.6c1.2.8 2.4 1.2 3.9 1.2 2 0 3-1 3-2.4 0-1.2-.8-2-3-3-2.8-1-4.3-2.6-4.3-4.7 0-2.6 2-4.7 5.5-4.7 1.4 0 2.8.4 4.1 1l-.6 2c-1-.6-2.2-1-3.2-1-1.4-.2-2.6.8-2.6 2.2 0 1.2 1 1.8 3 2.6 2.6 1 4.3 2.4 4.3 4.9 0 2.8-2.2 4.9-6.1 4.9-1.6 0-3-.4-4.5-1.2l.5-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    className: "st0",
    d: "M316.5 66.5c.2 4.3-3 8.1-7.3 8.3h-.6c-4.3 0-7.7-3.2-7.7-8.3 0-5.5 3.7-8.5 8.1-8.5 4.1 0 7.5 3.5 7.5 8.5zm-12.7 0c0 3.2 1.6 6.1 4.9 6.1s4.9-3 4.9-6.1c0-2.8-1.2-6.3-4.9-6.3s-4.9 3.5-4.9 6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    className: "st0",
    d: "M320.4 74.7v-14h-2.2v-2.2h2.2v-.8c-.2-2 .4-4.1 1.8-5.7 1-1 2.4-1.6 3.9-1.6.8 0 1.6.2 2.4.4l-.4 2.2c-.6-.2-1.2-.4-1.8-.4-2.4 0-3 2.2-3 4.7v1h3.9v2.2h-3.9v13.8l-2.9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    className: "st0",
    d: "M333.8 53.7v4.7h4.3v2.2h-4.3v8.7c0 2 .6 3 2.2 3 .6 0 1.2 0 1.6-.2l.2 2.2c-.8.4-1.6.4-2.6.4-1.2 0-2.2-.4-3.2-1.2-.8-1.2-1.2-2.8-1-4.3v-8.9h-2.4v-2.2h2.4v-3.9l2.8-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    className: "st0",
    d: "M227 135.8l-7.7 23.8h-10.2L234.9 84h11.6l25.8 75.5h-10.4l-8.1-23.8H227zm24.8-7.5l-7.3-21.7c-1.6-4.9-2.8-9.5-3.9-13.8h-.4c-1 4.5-2.2 9.1-3.7 13.6l-7.3 21.9h22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    className: "st0",
    d: "M320.2 157.7c-4.9 2.2-10.2 3.2-15.6 3.2-16.2 0-27-11.2-27-27.6s11.6-28.8 29-28.8c4.7 0 9.3.8 13.6 2.8l-2.2 7.5c-3.5-1.8-7.5-2.6-11.6-2.6-12.4 0-19.1 9.3-19.1 20.5 0 12.6 8.1 20.3 18.9 20.3 4.1 0 8.3-.8 12-2.6l2 7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    className: "st0",
    d: "M345.2 89.9v15.6h14v7.3h-14V142c0 6.7 1.8 10.6 7.3 10.6 1.8 0 3.9-.2 5.7-.6l.4 7.3c-1.8 1-4.9 1.4-8.9 1.4-4.1.2-7.9-1.4-10.6-4.1-2.6-3.2-3.7-7.7-3.7-14.2v-29.6h-8.5v-7.3h8.3V92.3l10-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    className: "st0",
    d: "M381.3 90.3c0 3.2-2.4 5.9-5.7 6.1h-.4c-3.2 0-5.9-2.4-5.9-5.5v-.4c-.2-3.2 2.4-6.1 5.7-6.1h.4c3.3-.4 5.9 2.4 5.9 5.9 0-.2 0-.2 0 0zm-10.9 69.4v-54.2h9.7v54h-9.7v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    className: "st0",
    d: "M400.4 105.5L411 136c1.8 4.9 3.2 9.5 4.5 14h.4c1.2-4.5 2.8-9.1 4.5-14l10.6-30.5h10.4l-21.3 54h-9.5l-20.5-54h10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    className: "st0",
    d: "M454.8 134.3c.2 13.4 8.7 18.9 18.5 18.9 7.1 0 11.6-1.2 15-2.8l1.6 7.1c-5.7 2.4-11.8 3.7-18.1 3.5-16.6 0-26.6-11.2-26.6-27.4 0-16.4 9.5-29.2 25.6-29.2 17.7 0 22.3 15.4 22.3 25.4 0 1.6-.2 3-.4 4.7h-37.9v-.2zm28.8-7.1c.2-6.1-2.6-15.8-13.6-15.8-9.9 0-14.4 9.1-15.2 15.8h28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    className: "st0",
    d: "M529.3 85.2c6.9-1 13.8-1.6 20.9-1.6 14 0 24 3.2 30.5 9.5 6.7 6.1 10.6 15 10.6 27 0 12.4-3.9 22.3-11 29.4-7.1 7.1-18.7 11-33.3 11-5.9 0-12-.2-17.9-1l.2-74.3zm10 66.8c3.2.4 6.5.6 9.7.6 20.9 0 32.3-11.6 32.3-32.1.2-17.9-9.9-29-30.5-29-3.9 0-7.7.4-11.6 1l.1 59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    className: "st0",
    d: "M615 90.3c0 3.2-2.4 5.9-5.7 6.1h-.4c-3.2 0-5.9-2.4-5.9-5.5v-.4c-.2-3.2 2.4-6.1 5.7-6.1h.4c3.1-.4 5.9 2.4 5.9 5.9 0-.2 0-.2 0 0zm-11.1 69.4v-54.2h9.7v54h-9.7v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    className: "st0",
    d: "M630 122.4c0-6.3-.2-11.8-.4-16.9h8.7l.4 10.6h.4c2.6-7.3 8.7-11.8 15.2-11.8 1 0 1.8 0 2.6.2v9.3c-1-.2-2-.4-3.2-.4-7.1 0-11.8 5.3-13.2 12.6-.4 1.4-.4 3-.4 4.5v29h-9.7l-.4-37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    className: "st0",
    d: "M671.1 134.3c.2 13.4 8.7 18.9 18.5 18.9 7.1 0 11.6-1.2 15-2.8l1.6 7.1c-5.7 2.4-11.8 3.7-18.1 3.5-16.6 0-26.6-11.2-26.6-27.4 0-16.4 9.5-29.2 25.6-29.2 17.7 0 22.3 15.4 22.3 25.4 0 1.6-.2 3-.4 4.7h-37.9v-.2zm28.8-7.1c.2-6.1-2.6-15.8-13.6-15.8-9.9 0-14.4 9.1-15.2 15.8h28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    className: "st0",
    d: "M760.2 157.7c-4.9 2.2-10.2 3.2-15.6 3.2-16.2 0-27-11.2-27-27.6s11.6-28.8 29-28.8c4.7 0 9.3.8 13.6 2.8l-2.2 7.5c-3.5-1.8-7.5-2.6-11.6-2.6-12.4 0-19.1 9.3-19.1 20.5 0 12.6 8.1 20.3 18.9 20.3 4.1 0 8.3-.8 12-2.6l2 7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    className: "st0",
    d: "M785.2 89.9v15.6h14v7.3h-14V142c0 6.7 1.8 10.6 7.3 10.6 1.8 0 3.9-.2 5.7-.6l.4 7.3c-1.8 1-4.9 1.4-8.9 1.4-4.1.2-7.9-1.4-10.6-4.1-2.6-3.2-3.7-7.7-3.7-14.2v-29.6h-8.3v-7.3h8.3V92.3l9.8-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    className: "st0",
    d: "M858.7 132.5c0 19.9-14.6 28.4-27.2 28.4-14.2 0-25.8-10.6-25.8-28.2 0-18.1 12.4-28.4 27-28.4 15.2 0 26 10.8 26 28.2zm-42.9.2c0 11 5.5 20.7 16.4 20.7 10.8 0 16.6-9.7 16.6-20.9 0-9.5-4.5-21.1-16.6-21.1-12.1 0-16.4 11.6-16.4 21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    className: "st0",
    d: "M871.1 122.4c0-6.3-.2-11.8-.4-16.9h8.7l.4 10.6h.4c2.6-7.3 8.7-11.8 15.2-11.8 1 0 1.8 0 2.6.2v9.3c-1-.2-2-.4-3.2-.4-7.1 0-11.8 5.3-13.2 12.6-.4 1.4-.4 3-.4 4.5v29h-9.7l-.4-37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    className: "st0",
    d: "M914.1 105.5l11.8 31.9c1.2 3.5 2.6 7.7 3.5 11.2h.2c1-3.2 2-7.3 3.5-11.2l10.8-31.9h10.4l-14.8 38.6c-7.1 18.5-11.8 28.2-18.5 34.1-3.5 3-7.5 5.1-12 6.3l-2.4-8.3c3.2-1 6.1-2.6 8.7-4.9 3.5-3 6.3-6.7 8.1-11 .4-.8.8-1.6.8-2.4 0-1-.4-1.8-.8-2.6l-19.9-49.7h10.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsAdLogo);
export default __webpack_public_path__ + "static/media/ms-ad-logo.285911934ebd6079e289086520520841.svg";
export { ForwardRef as ReactComponent };